module.exports = __webpack_public_path__ + "img/svgBanderaMobile.7b6f0f75.svg";